/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Suffix_HelpInputs */

const en_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appended to the original filename before the extension.`)
};

const fr_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté au nom de fichier original avant l'extension.`)
};

const de_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird vor der Dateiendung an den ursprünglichen Dateinamen angehängt.`)
};

const it_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiunto al nome del file originale prima dell'estensione.`)
};

const ru_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавляется к исходному имени файла перед расширением.`)
};

const es_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se añade al nombre de archivo original antes de la extensión.`)
};

const zh_cn2_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在原始文件名的扩展名之前附加。`)
};

const ja_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡張子の前に元のファイル名に追加されます。`)
};

const hi_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सटेंशन से पहले मूल फ़ाइल नाम में जोड़ा जाता है।`)
};

const pt_pt2_audio_embed_export_suffix_help = /** @type {(inputs: Audio_Embed_Export_Suffix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionado ao nome do arquivo original antes da extensão.`)
};

/**
* | output |
* | --- |
* | "Appended to the original filename before the extension." |
*
* @param {Audio_Embed_Export_Suffix_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_suffix_help = /** @type {((inputs?: Audio_Embed_Export_Suffix_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Suffix_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_suffix_help(inputs)
	if (locale === "de") return de_audio_embed_export_suffix_help(inputs)
	if (locale === "it") return it_audio_embed_export_suffix_help(inputs)
	if (locale === "ru") return ru_audio_embed_export_suffix_help(inputs)
	if (locale === "es") return es_audio_embed_export_suffix_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_suffix_help(inputs)
	if (locale === "ja") return ja_audio_embed_export_suffix_help(inputs)
	if (locale === "hi") return hi_audio_embed_export_suffix_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_suffix_help(inputs)
	return en_audio_embed_export_suffix_help(inputs)
});